<template>
	<div v-if="showPoster" class="c-media-block-video__poster">
		<slot></slot>

		<DsButton
			variant="primary-inverted"
			iconStart="button-play"
			class="c-media-block-video__poster-play"
			:clickHandler="playVideo"
		>
			{{ vm.baseViewModel.videoCtaLinkLabel }}
		</DsButton>
	</div>

	<iframe
		v-else
		class="c-media-block-video__iframe"
		:title="vm.baseViewModel.videoIFrameTitle ?? vm.baseViewModel.title"
		:data-src="embedUrl"
		allow="autoplay; fullscreen"
		:src="embedUrl"
		data-testid="media-video-player"
	>
	</iframe>
</template>

<script setup>
import { computed, ref } from 'vue';
import { DsButton } from '@coloplast/design-system';
import { normalizeVideo } from 'shared/utils/videoEmbed.utils';

const props = defineProps({
	vm: {
		type: Object,
		default: () => {},
	},
});

const normalized = ref(normalizeVideo(props.vm.baseViewModel.vimeoVideoUrl));
const embedUrl = computed(() => normalized.value.embedUrl);
const showPoster = ref(!!props.vm.baseViewModel.videoPosterImageUrl);

const playVideo = () => {
	showPoster.value = false;
};
</script>
